import axios from './../../api';
import store from './../../store';

export default {
  namespaced: true,

  state: {
    beneficiaries: null,
    urlCursor: undefined,
    templates: [],
    beneficiaryToEdit: {},
    errors: null,
  },
  getters:{
    beneficiaries(state){
      return state.beneficiaries;
    },

    urlCursor(state){
      return state.urlCursor;
    },

    templates(state){
      return state.templates;
    },

    beneficiaryToEdit(state){
      return state.beneficiaryToEdit;
    },
    errors(state){
      return state.errors;
    }
  },
  mutations: {
    SET_BENEFICIARIES(state, list){
      let uniqueIds = [];
      let beneficiaries = [];

      for (const beneficiary of list) {
        if (! uniqueIds.includes(beneficiary.id) ) {
          uniqueIds.push(beneficiary.id);
          beneficiaries.push(beneficiary);
        }
      }

      state.beneficiaries = beneficiaries;
    },

    SET_URLCURSOR(state, str){
      state.urlCursor = str;
    },

    SET_TEMPLATES(state, list){
      state.templates = list;
    },

    SET_BENEFICIARYTOEDIT(state, beneficiary){
      state.beneficiaryToEdit =  JSON.parse(JSON.stringify(beneficiary));
    },
    SET_ERRORS(state, err){
      state.errors = err;
    }
  },
  actions:{
    /**
     * load all beneficiaries created in current company
     * @param {*} context
    */
    async loadBeneficiaries(context, {hasLoading = true, hasPagination = 0, search='', orderBy='lastname', direction='ASC', perPage=10}){
      console.log('wait...loading beneficiaries');

      if(hasLoading)
        store.commit('app/SET_LOADING', true);

      let cursor = context.getters.urlCursor;

      await axios.post('api/loadBeneficiaries?paginated='+hasPagination+'&cursor='+cursor,
        {
          search: search,
          orderBy: orderBy,
          direction: direction,
          perPage: perPage,
        }).then((response) => {
        let datas = response.data;
        let listNeopassBefore = context.getters.beneficiaries && cursor != '' ? context.getters.beneficiaries : [];
        context.commit('SET_BENEFICIARIES', [...listNeopassBefore, ...datas.beneficiaries]);
        if (datas.nextCursor === '') {

        } else {
          context.commit('SET_URLCURSOR', datas.nextCursor);
        }
        store.commit('permissions/SET_SAVING', false);
        if(hasLoading)
          store.commit('app/SET_LOADING', false);
      }).catch(() => {
        store.commit('app/SET_LOADING', false);
      });
    },

    /**
         * load all user/company templates
         * @param {*} context
         */
    async loadTemplates(context){
      console.log('wait...loading templates');
      await axios.get('api/page_templates').then((response) => {
        let templates = response.data.filter(t => t.is_active == '1').map(temp => {
          return {
            id: temp.id,
            page: temp.page_name,
            value: temp.name,
            inProgress: temp.is_used_in_evaluation,
          };
        });

        context.commit('SET_TEMPLATES', templates);
      });
    },

    /**
         * Create a new beneficiary in an organisation
         * @param {*} context
         */
    async createBeneficiary(context, newBeneficiary){
      return await axios.post('/api/beneficiaries', { beneficiary: newBeneficiary }).then((response) => {

        //add permissions to permissionsOnBeneficiariesNeopass in auth Store
        axios.get('/api/user-rights').then((r2) => {
          store.commit('auth/SET_PERMISSIONSONBENEFICIARIESNEOPASS', r2.data);
        });

        return response.data;

      }).catch(error => {
        throw {...error.response.data.errors};
      });
    },

    /**
         * Link an existing beneficiary to the actual organisation
         * @param {*} context
         */
    async attachBeneficiary(context, newBeneficiary){
      return await axios.post('/api/users/attachNeopass', { user: newBeneficiary }).then((response) => {
        if(response.data.message == 'ok'){
          //add permissions to permissionsOnBeneficiariesNeopass in auth Store
          axios.get('/api/user-rights').then((r2) => {
            store.commit('auth/SET_PERMISSIONSONBENEFICIARIESNEOPASS', r2.data);
          });
          return response.data;
        }
      }).catch(error => {
        throw error.response.data;
      });
    },

    async detachBeneficiary(context){
      let beneficiary = context.getters.beneficiaryToEdit;
      let name = beneficiary.firstname+' '+beneficiary.lastname;

      store.commit('app/SET_LOADING', true);

      await axios.put('/api/beneficiaries/detach/' + beneficiary.id).then(() => {
        context.dispatch('loadBeneficiaries', { hasLoading: true, hasPagination: 0, });
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Le Neopass de '+name+' a bien été détaché de la structure'});
        setTimeout(() => { store.commit('permissions/SET_MESSAGEHEADER', null); }, 3000);
        store.commit('app/SET_LOADING', false);
      }).catch(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Une erreur est survenue, le Neopass de '+name+' n\'a pas pu être détaché de la structure'});
        setTimeout(() => { store.commit('permissions/SET_MESSAGEHEADER', null); }, 3000);
        store.commit('app/SET_LOADING', false);
      });
    },

    /**
         * Save beneficiary informations modified by id (id beneficiary is in editBeneficiary)
         * @param {*} context
         */
    async saveBeneficiary(context){
      store.commit('permissions/SET_SAVING', true);
      let beneficiary = context.getters.beneficiaryToEdit;

      await axios.put('/api/users/'+beneficiary.id, {user: beneficiary}).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Les informations du bénéficiaire '+beneficiary.firstname+' '+beneficiary.lastname+' ont bien été modifiées'});
        context.dispatch('loadBeneficiaries', { hasLoading: true, hasPagination: 0, });
        context.commit('SET_ERRORS', null);
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      })
        .catch(error => {
          context.commit('SET_ERRORS', error.response.data.errors);
          store.commit('permissions/SET_SAVING', false);
          store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d\'enregistrement des données.'});
          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
          console.log('ERRRR:: ', error.response.data);
        });
    },

    /**
         * Load all beneficiary rights by id beneficiary
         *
         * @param {*} context
         * @param {*} id id beneficiary that want to load
         */
    async loadBeneficiaryRights(context, id){
      store.commit('permissions/SET_SAVING', true);

      return await axios.get('/api/user-rights/specificRights/' + id).then(response => {
        store.commit('permissions/SET_SAVING', false);
        return response.data;
      }).catch(() => {
        store.commit('permissions/SET_SAVING', false);
      });

    },

    /**
         * Load all beneficiary templates by id beneficiary
         * @param {*} context
         * @param {*} id id beneficiary that whant to load
         * @returns
         */
    async loadBeneficiaryTemplates(context, id){
      store.commit('permissions/SET_SAVING', true);

      return await axios.get('/api/user-rights/templates/' + id).then(response => {
        console.log('templates out', response.data);
        store.commit('permissions/SET_SAVING', false);
        return response.data;
      }).catch(() => {
        store.commit('permissions/SET_SAVING', false);
      });

    },

    /**
         * Save beneficiary rights
         * @param {*} context
         * @param int id
         */
    async saveBeneficiaryRights(context) {
      store.commit('permissions/SET_SAVING', true);

      let beneficiary = context.getters.beneficiaryToEdit;

      await axios.put('/api/user-rights/' + beneficiary.id, { rights: beneficiary.rights }).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', { type: 'success', msg: 'Les droits du bénéficiaire '+beneficiary.firstname+' '+beneficiary.lastname+' ont bien été enregistrés.' });
        context.dispatch('loadBeneficiaries', { hasLoading: true, hasPagination: 0, });
        store.commit('permissions/SET_SAVING', false);
        setTimeout(() => { store.commit('permissions/SET_MESSAGEHEADER', null); }, 3000);
      })
        .catch(error => {
          store.commit('permissions/SET_MESSAGEHEADER', { type: 'error', msg: 'Erreur d`\'enregistrement des données.' });
          setTimeout(() => { store.commit('permissions/SET_MESSAGEHEADER', null); }, 3000);
          console.log('ERRRR:: ', error.response.data);
        });
    },

    async saveBeneficiaryTemplates(context){
      store.commit('permissions/SET_SAVING', true);
      let beneficiary = context.getters.beneficiaryToEdit;

      await axios.post('/api/beneficiaries/templates/save/'+beneficiary.id, {templates: beneficiary.templates}).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Les modèles de pages du bénéficiaire '+beneficiary.firstname+' '+beneficiary.lastname+' ont bien été enregistrés.'});
        context.dispatch('loadBeneficiaries', { hasLoading: true, hasPagination: 0, });
        store.commit('permissions/SET_SAVING', false);
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      })
        .catch(error => {
          store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});
          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
          console.log('ERRRR:: ', error.response.data);
        });
    },

    async saveNewPassword(context, authPassword){

      store.commit('permissions/SET_SAVING', true);
      let beneficiary = context.getters.beneficiaryToEdit;

      await axios.post('/api/users/changePassword/'+beneficiary.id,
        {
          newPassword: {
            password: beneficiary.password,
            password_confirmation: beneficiary.password_confirmation,
          },
          authPassword: authPassword,
        }
      ).then((response) => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: response.data.msg});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        store.commit('permissions/SET_SAVING', false);
        context.commit('SET_ERRORS',null);
      })
        .catch(error => {
          if(error.response.status === 403){
            context.commit('SET_ERRORS', {authPassword:[error.response.data.msg]});
          }else{
            context.commit('SET_ERRORS', error.response.data.errors);
          }
          store.commit('permissions/SET_SAVING', false);
        });
    },
  },
};
